import {} from '@rocicorp/zero';
import { uuidv7 } from 'uuidv7';
/**
 * Appends one row to the stock movements log (CY-83). Every change of a batch quantity must call this
 * at least once, and the rows of one change add up to it (production start writes one per prescription,
 * CY-370); movements are append-only and are never edited or deleted afterwards.
 */
export function recordStockMovement(tx, ctx, movement, performedAt = Date.now()) {
    return tx.mutate.stockMovements.insert({
        id: uuidv7(),
        type: movement.type,
        performedAt,
        batchId: movement.batchId ?? null,
        quantity: movement.quantity ?? null,
        quantityUnitId: movement.quantityUnitId ?? null,
        packages: movement.packages ?? null,
        source: movement.source ?? null,
        reason: movement.reason ?? null,
        note: movement.note ?? null,
        stockLocationId: movement.stockLocationId ?? null,
        sequenceId: movement.sequenceId ?? null,
        orderId: movement.orderId ?? null,
        restVialId: movement.restVialId ?? null,
        returnId: movement.returnId ?? null,
        discardId: movement.discardId ?? null,
        deliveryNoteNumber: movement.deliveryNoteNumber ?? null,
        createdBy: ctx.user.id,
        createdAt: performedAt,
    });
}
//# sourceMappingURL=stock-movements.js.map